import React from 'react';

import TempGraph from '../graph';

const data = [

  {
    id: '1',
    label: 'febre alta',
    value: 1,
    color: 'rgba(147, 187,255, 0.4)',
  },


];

function TemperatureChart(props) {
  const interactive = (props.data[0] && props.data[0].value) === 0 && (props.data[1] && props.data[1].value) === 0;
  const dataGraph = (props.data[0] && props.data[0].value) === 0 && (props.data[1] && props.data[1].value) === 0 ? data : props.data;

  return <TempGraph data={dataGraph} isInteractive={!interactive} />;
}

export default TemperatureChart;

